import { useEffect, useState } from "react";
import { useDebounce } from "../../../../utils";
export type SearchProps = {
  locationHint: Coordinates | null;
  searchLocations?: string;
  searchTerm: string;
};
export type Coordinates = {
  latitude: number;
  longitude: number;
};
export type AutoCompleteLocation = {
  coordinate: Coordinates;
  displayLines: string[];
};
export function useMapAutoComplete(props: SearchProps): [boolean, AutoCompleteLocation[]] {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [search, setSearch] = useState<mapkit.Search>(new mapkit.Search());
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<AutoCompleteLocation[]>([]);
  const debouncedSearchTerm = useDebounce(props.searchTerm, 500);
  const resultHandler = (error: Error | null, data: mapkit.SearchAutocompleteResponse) => {
    const suggestions: AutoCompleteLocation[] = [];
    setIsLoading(false);
    data.results.forEach(suggestion => {
      if (suggestion.coordinate) {
        suggestions.push({
          coordinate: {
            latitude: suggestion.coordinate.longitude,
            longitude: suggestion.coordinate.latitude
          },
          displayLines: suggestion.displayLines
        });
      }
    });
    setData(suggestions);
  };
  useEffect(() => {
    if (!debouncedSearchTerm || debouncedSearchTerm.length < 3) {
      return;
    }
    const options: mapkit.SearchOptions = {};
    if (props.locationHint) {
      options.coordinate = new mapkit.Coordinate(props.locationHint.latitude, props.locationHint.longitude);
    }
    if (props.searchLocations) {
      options.limitToCountries = props.searchLocations;
    }
    search.autocomplete(debouncedSearchTerm, resultHandler, options);
  }, [debouncedSearchTerm, search, props.locationHint]);
  return [isLoading, data];
}